import React, { useState } from "react";
import { Button, Toast, ToastHeader, ToastBody } from "reactstrap";
import { useDispatch } from "react-redux";
import { setAgentToChat } from "store/auth/agent/agentSlice";

const ContactAgentButton = ({ agent }) => {
    const dispatch = useDispatch();
    const [showToast, setShowToast] = useState(false);

    const handleClick = () => {
        if (!agent?.initiatedByAgent) {
            setShowToast(true);
            return;
        }
        dispatch(setAgentToChat(agent));
    };

    return (
        <div className="w-100">
            <Button
                color="primary"
                className={`px-5 ${!agent?.initiatedByAgent ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                onClick={handleClick}
            >
                Contacter
            </Button>

            <div
                aria-live="polite"
                aria-atomic="true"
                className="position-sticky top-0 start-0 end-0 w-100 p-0"
                style={{ zIndex: 9999, marginTop: "20px" }}
            >
                <Toast isOpen={showToast} fade={false} className="w-100">
                    <ToastHeader icon="warning" toggle={() => setShowToast(false)}>
                        Attention
                    </ToastHeader>
                    <ToastBody className="w-100">
                        C&apos;est l&apos;agent qui doit communiquer en premier.
                    </ToastBody>
                </Toast>
            </div>

        </div>
    );
};

export default ContactAgentButton;
